import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondToMmss',
  standalone: true
})
export class SecondToMmssPipe implements PipeTransform {

  transform(value: number): string {
    if (isNaN(value) || value < 0) {
      return '00:00';
    }

    const minutes = Math.floor(value / 60);
    const seconds = value % 60;

    const paddedMinutes = minutes.toString().padStart(2, '0');
    const paddedSeconds = seconds.toString().padStart(2, '0');

    return `${paddedMinutes} : ${paddedSeconds}`;
  }

}
